module.exports = __webpack_public_path__ + "img/menu_AVAL.770762dc.svg";